export default "__VITE_ASSET__BN_05BtW__"